<span nz-icon>
  <svg [attr.width]="size" [attr.height]="size" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1.002 1.002 0 1 0-1.41-1.42ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z"
      fill="currentColor"
    />
  </svg>
</span>
